<template>


    <div class="selected-marker-container" :class="{double: hasArea}">
      <div   class="info">
<!--        <div class="marker-label">info</div>-->
      <template v-if="what">
        <div class="marker-info-label">Wat doet ark hier?</div>
        <div :key="key" v-for="(group, key) in what">
          <div class="tag-group-label" @click="showTag(key)">
            <svg class="svg-circle" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.0625 10.0001C20.0625 15.2468 15.8092 19.5001 10.5625 19.5001C5.31579 19.5001 1.0625 15.2468 1.0625 10.0001C1.0625 4.75336 5.31579 0.500061 10.5625 0.500061C15.8092 0.500061 20.0625 4.75336 20.0625 10.0001Z" :fill="'url(#paint0_linear_15_1135' + key + ')'" stroke="#0A5256"/>
              <defs>
                <linearGradient :id="'paint0_linear_15_1135' + key" x1="10.5625" y1="6.10352e-05" x2="10.5625" y2="20.0001" gradientUnits="userSpaceOnUse">
                  <stop :stop-color="stopColor(key)"/>
                  <stop offset="1" :stop-color="offsetColor(key)"/>
                </linearGradient>
              </defs>
            </svg>
            <div class="inner">
              {{ getTag(key).name }}
            </div>
            <svg class="filter-link" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.863 11.8885V17.8885M20.863 11.3885C20.863 16.9113 16.3858 21.3885 10.863 21.3885C5.34013 21.3885 0.862976 16.9113 0.862976 11.3885C0.862976 5.86564 5.34013 1.38849 10.863 1.38849C16.3858 1.38849 20.863 5.86564 20.863 11.3885ZM12.863 6.88849C12.863 7.99306 11.9675 8.88849 10.863 8.88849C9.75841 8.88849 8.86298 7.99306 8.86298 6.88849C8.86298 5.78392 9.75841 4.88849 10.863 4.88849C11.9675 4.88849 12.863 5.78392 12.863 6.88849Z" stroke="black" stroke-linecap="round"/>
            </svg>
          </div>
          <TagsComponent :group="group" :stop-color="stopColor(key)" :offset-color="offsetColor(key)"  />
        </div>

      </template>
      <template v-if="tasks">
        <div class="marker-info-label marker-info-label-tasks">Dit draagt bij aan</div>
        <div v-for="item in tasks">
          <div @click="showTag(item.tid)"  class="tag-label task">
            <svg class="svg-circle" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.5 7.00013C13.5 10.59 10.5899 13.5001 7 13.5001C3.41015 13.5001 0.5 10.59 0.5 7.00013C0.5 3.41028 3.41015 0.500122 7 0.500122C10.5899 0.500122 13.5 3.41028 13.5 7.00013Z" fill="#434343" stroke="#434343"/>
            </svg>
            <div class="inner">
              {{ item.name }}
            </div>
            <svg class="filter-link" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.863 11.8885V17.8885M20.863 11.3885C20.863 16.9113 16.3858 21.3885 10.863 21.3885C5.34013 21.3885 0.862976 16.9113 0.862976 11.3885C0.862976 5.86564 5.34013 1.38849 10.863 1.38849C16.3858 1.38849 20.863 5.86564 20.863 11.3885ZM12.863 6.88849C12.863 7.99306 11.9675 8.88849 10.863 8.88849C9.75841 8.88849 8.86298 7.99306 8.86298 6.88849C8.86298 5.78392 9.75841 4.88849 10.863 4.88849C11.9675 4.88849 12.863 5.78392 12.863 6.88849Z" stroke="black" stroke-linecap="round"/>
            </svg>

            </div>
        </div>
      </template>
      </div>
      <div class="area" v-if="hasArea">
        <div class="marker-label gebiedsinfo">gebiedsinfo</div>
        <div  v-if="areaImage">
          <img  class="feature-image" :src="areaImage.src"  :alt="areaImage.alt">
        </div>
        <div class="verdieping field--name-body" v-html="areaInfo"></div>


        <div class="verdieping verdieping-links">
          <a v-if="selected_marker.area && selected_marker.area_published ==1" href="#" @click.prevent="openArea">Meer info over {{selected_marker.area}}</a>
          <a v-if="selected_marker.program" href="#" @click.prevent="openProgram">Onderdeel van {{selected_marker.program}}</a>

        </div>
        <PartnersComponent :selected_marker="selected_marker" :marker="true"/>

      </div>
    </div>
</template>

<script lang="ts" setup>
import {computed} from 'vue';
import PartnersComponent from "./PartnersComponent.vue";
import TagsComponent from "./TagsComponent.vue";


const props = defineProps({
  selected_marker: Object,
  tags: Array,
  filters: Array,
});

const emit = defineEmits(['show-tag', 'show-area', 'show-program'])

const what = computed(() => {
  return groupBy(props.tags.filter(tag => props.selected_marker.what.indexOf(tag.tid) != -1).sort((a, b) => a.parent_target_id.localeCompare(b.parent_target_id) ), 'parent_target_id');
})

const tasks = computed(() => {
  return props.tags.filter(tag => props.selected_marker.tasks.indexOf(tag.tid) != -1);
})

const hasArea = computed(() => {
  return props.selected_marker && (props.selected_marker.program != '' || props.selected_marker.area != '');
})

const hasProgram = computed(() => {
  return props.selected_marker.program != '';
})

const areaInfo = computed(() => {
  return props.selected_marker.area != '' ? props.selected_marker.area_summary : props.selected_marker.program_summary;
})


const areaImage = computed(() => {

  if(images.value.length > 0) {
    return images.value[0];
  }
  return null;


})

const images = computed(() => {
  let items  = [];

  let images = props.selected_marker.area != '' ? props.selected_marker.area_images : props.selected_marker.program_images;

  images = images.split('<img');



  images.forEach((image) => {
    if(image.match(/src="([^"]*)"/) != null && image.match(/src="([^"]*)"/)[1] != null) {
      let item = {
        src:  image.match(/src="([^"]*)"/)[1],
        alt: ''
      };
      if(image.match(/alt="([^"]*)"/) != null && image.match(/alt="([^"]*)"/)[1] != null) {
        item.alt = image.match(/alt="([^"]*)"/)[1];
      }

      items.push(item)
    }

  })
  return items;

})





function stopColor(tid) {
  return props.filters.find(filter => filter.tid == tid).color;
}
function offsetColor(tid) {
  return props.filters.find(filter => filter.tid == tid).offset_color;
}
function getTag(id) {
  return props.tags.find(tag => tag.tid === id);
}
function showTag(id) {
  emit('show-tag', id);
}
function groupBy(xs, key) {
  return xs.reduce(function(rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}

function openArea() {
  emit('show-area');
}
function openProgram() {
  emit('show-program');
}



</script>
